export const isStagingEnvironment = () => {
  return window.location.host.includes("staging-cap-rx");
};

export const isQAEnvironment = () => {
  return window.location.host.includes("qa-cap-rx");
};

export const isLocalEnvironment = () => {
  return (
    (window.location.hostname.match(/\d+\.\d+\.\d+\.\d+/) || window.location.hostname === "localhost") && window.location.port === "7000"
  );
};

export const isDemoEnvironment = () => {
  return window.location.host.includes("demo-cap-rx");
};

export const isUATEnvironment = () => {
  return window.location.host.includes("uat-cap-rx");
};

export const isPrimeEnvironment = () => {
  return window.location.host.includes("prime-cap-rx");
};

export const isPrimeQAEnvironment = () => {
  return window.location.host.includes("primeqa-cap-rx");
};

export const isPrimeUATEnvironment = () => {
  return window.location.host.includes("primeuat-cap-rx");
};

export const isAllianceEnvironment = () => {
  return window.location.host.includes("alliance-cap-rx");
};

/**
 * Feature flag for CapitalRx -> Judi Health rebrand
 */
export const enableJudiHealthBranding = () => {
  // enable rebrand earlier in lower environments
  if (isStagingEnvironment() || isQAEnvironment() || isLocalEnvironment()) {
    const LAUNCH_DATE = new Date("July 6, 2026, 12:00:00 PM EDT");
    const now = new Date();
    return now >= LAUNCH_DATE;
  }

  const LAUNCH_DATE = new Date("July 15, 2026, 00:00:00 AM EDT");
  const now = new Date();
  return now >= LAUNCH_DATE;
};
